import { render } from "./Prediction.vue?vue&type=template&id=1ecb8366&ts=true"
import script from "./Prediction.vue?vue&type=script&lang=ts"
export * from "./Prediction.vue?vue&type=script&lang=ts"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__